import { Action, combineReducers } from 'redux'
import { ThunkAction } from 'redux-thunk'
import leadReducer from './lead/leadSlice'
import animationReducer from './animation/animationSlice'
import areaReducer from './area/areaSlice'
import locationReducer from './location/locationSlice'
import userReducer from './user/userSlice'
import valuationReducer from './valuation/valuationSlice'
import addressReducer from './address/addressSlice'
import valuationPdfReducer from './valuationPdf/valuationPdfSlice'
import flowSlice from './flow/flowSlice'
import configSlice from './config/configSlice'
import iv24TrackingSlice from './immoverkauf24/trackingSlice'

const rootReducer = combineReducers({
  lead: leadReducer,
  area: areaReducer,
  location: locationReducer,
  user: userReducer,
  valuation: valuationReducer,
  animation: animationReducer,
  address: addressReducer,
  valuationPdf: valuationPdfReducer,
  flow: flowSlice,
  config: configSlice,
  iv24TrackingData: iv24TrackingSlice,
})

export type ReduxState = ReturnType<typeof rootReducer>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, ReduxState, unknown, Action<string>>

export default rootReducer
